import { render, staticRenderFns } from "./BudgetCommission1.vue?vue&type=template&id=8f2497a4&scoped=true&"
import script from "./BudgetCommission1.vue?vue&type=script&lang=js&"
export * from "./BudgetCommission1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2497a4",
  null
  
)

export default component.exports